"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAppBarNotificationPopoverContent = exports.StyledAppBarNotificationPopoverList = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const constants_1 = require("../../helpers/constants");
const getNotificationListMaxHeight_1 = require("../../helpers/getNotificationListMaxHeight");
const StackView_1 = require("../../../../../StackView");
exports.StyledAppBarNotificationPopoverList = styled_components_1.default.div `
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    max-height: ${({ isFooterEnabled }) => `${(0, getNotificationListMaxHeight_1.getNotificationListMaxHeight)(isFooterEnabled)}px`};
`;
exports.StyledAppBarNotificationPopoverContent = (0, styled_components_1.default)(StackView_1.StackView) `
    max-width: ${`${constants_1.APP_BAR_NOTIFICATION_MAX_WIDTH_POPOVER}px`};
    max-height: 100%;
`;
//# sourceMappingURL=AppBarNotificationPopover.styles.js.map